import { useState } from 'react';
import TextField from '@mui/material/TextField';
import { webSavedSearchNameCharCountLimit } from '@Components/Utilities/SandhillsConstants';


const WebSavedSearchItem = (props) => {
    const [showEdit, setShowEdit] = useState(false);
    const [name, setName] = useState(props.SearchName);

    const toggleEdit = () => {
        setShowEdit(!showEdit);

        if (showEdit) {
            props.updateWebSavedSearch(props.WebSavedSearchID, name);
        } else {
            setName(props.SearchName);
        }
    };

    const textChange = (e) => {
        setName(e);
        props.setPendingSearchName(e);
    };
    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            props.updateWebSavedSearch(props.WebSavedSearchID, name);
            toggleEdit();
        }
    };
    const closeEdit = () => {
        setShowEdit(false);
    }


    return (
        <div className='saved-searches__saved-search-row'>
            <div className='row-content'>
                {showEdit ?
                    <TextField id="saved-search-name" variant="standard"
                        className='saved-searches__update-text-input'
                        placeholder={translator.translate('sandhills.tradesites.mvc.enternameforsavedsearch')}
                        label={translator.translate('sandhills.tradesites.mvc.enternameforsavedsearch')}
                        sx={{ 'width': '80%' }}
                        value={name}
                        InputLabelProps={{ className: 'visually-hidden', shrink: true }}
                        onChange={(e) => textChange(props.truncateText(e.target.value, webSavedSearchNameCharCountLimit))}
                        autoFocus={true}
                        onKeyPress={onKeyPress}
                        onFocus={e => { e.target.select(); }} />
                    :
                    <a href={props.SearchURL}>{props.SearchName}&nbsp;<i className="fas fa-external-link-alt"></i></a>
                }
                <div className='button-icons'>
                    <i role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleEdit(); } }} onClick={() => toggleEdit()} className={showEdit ? 'fas fa-save' : "fas fa-pencil-alt"} title={showEdit ? translator.translate('sandhills.photosvideos.savechanges') : translator.translate('sandhills.edit')} />
                    <i role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showEdit ? closeEdit() : props.removeWebSavedSearch(props.WebSavedSearchID) } }} onClick={() => showEdit ? closeEdit() : props.removeWebSavedSearch(props.WebSavedSearchID)} className={showEdit ? 'fas fa-x' : 'fas fa-trash'} title={showEdit ? translator.translate('sandhills.closepage') : translator.translate('sandhills.delete')} />
                </div>
            </div>
        </div>
    )

}

export default WebSavedSearchItem
